module.exports = __webpack_public_path__ + "static/favicons/apple-touch-icon-60x60-bcda1156da79ecb2b039971955ee12df.png";